import {
    LinkService
} from "../services/link.service";
import {
    SEND_EMAIL_ACTION,
    GET_DRAWING_ACTION,
    GET_STREAM_LINK_ACTION
} from "./actions.type";
import {
    SEND_EMAIL_MUTATION,
    GET_DRAWING_MUTATION,
    GET_STREAM_LINK_MUTATION
} from "./mutations.type";

const initialState = {
    drawing: "",
    stream: ""
};

export const state = { ...initialState };

export const actions = {
    async [SEND_EMAIL_ACTION](context, params) {
        const { data } = await LinkService.save(params);
        context.commit(SEND_EMAIL_MUTATION, data);
        return data;
    },
    async [GET_DRAWING_ACTION](context, params) {
        const { data } = await LinkService.getDrawing(params);
        context.commit(GET_DRAWING_MUTATION, data);
        return data;
    },
    async [GET_STREAM_LINK_ACTION](context, params) {
        const { data } = await LinkService.getStreamLink(params);
        context.commit(GET_STREAM_LINK_MUTATION, data);
        return data;
    }
};

export const mutations = {
    [GET_DRAWING_MUTATION](state, drawing) {
        state.drawing = drawing;
    },
    [GET_STREAM_LINK_MUTATION](state, stream) {
        state.stream = stream;
    },
};

const getters = {
    drawing(state) {
        return state.drawing;
    },
    stream(state) {
        return state.stream;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
